import React from 'react';
import powers from '../../../json/powers';
import '../../../css/powerCards.css';

function Powers(props){
  const powerCards = props.data.map(power=>{
    const key="power_"+power.split(' ').join('');
    const pd = powers.filter(data=>{
      return data.name === power;
    })[0];

    if(!pd){
      throw Error("Could not resolve power "+ power)
    }

    return (
      <div key={key} className="power card">
        <div className="header">{power}</div>
        <div className="content">
          Activation: {pd.activation} / Strain: {pd.strain}<br />
      {pd.category}
          <div className="description">
            {pd.description}
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="powerCards">
      {powerCards}
    </div>
  );
}

export default Powers;
